import React from 'react'
import View from '@modul-connect/shared/components/atoms/view'
import { A } from '@modul-connect/shared/components/atoms/text'
import { Icon } from '@modul-connect/shared/components/atoms/icon/icon'
import theme from '@modul-connect/shared/theme'
import Button from '@modul-connect/shared/components/atoms/button'

export const ReportDownloadButton = ({ onClick, disabled }) => {
  return (
    <Button disabled={disabled} extend={{
      borderRadius: theme.layout.grid / 2,
      backgroundColor: theme.colors.darkerGrey,
      height: '40px',
      width: '210px',
    }} onClick={onClick} noPadding>
      <View style={{
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        alignItems: 'center',
      }}>
        <A extend={{ color: 'white' }} >
          {'DOWNLOAD PERIOD'}
        </A>
        <Icon style={{}} icon={'DownloadWhite'} />
      </View>
    </Button>
  )
}

export const ReportDownloadAllButton = ({ onClick, disabled }) => {
  return (
    <Button
      disabled={disabled}
      extend={{
        width: '300px',
        height: '35px',
        gap: '12px',
        paddingTop: '8px',
        paddingRight: '20px',
        paddingBottom: '8px',
        paddingLeft: '20px',
        borderRadius: '4px',
        border: '1px solid black',
        borderColor: theme.colors.black,
        backgroundColor: disabled ? theme.colors.disabledGrey :  'white',
        textTransform: 'auto',
        cursor: disabled ? 'default' : 'pointer'
      }}
      onClick={onClick}
      noPadding
    >
      <View
        style={{
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-evenly',
          alignItems: 'center',
        }}
      >
        <A extend={{ cursor: disabled ? 'default' : 'pointer', color: theme.colors.downloadBlue, fontSize: '14.5px' }}>Download report to excel</A>
        <Icon icon="DownloadCloud" />
      </View>
    </Button>
  )
}